var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaxDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 102,
    viewBox: "0 0 82 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3882",
    "data-name": "Group 3882",
    transform: "translate(-22039 -2185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    transform: "translate(22039 2185)",
    fill: "none",
    stroke: "#0182f0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 102,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80,
    height: 100,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    transform: "translate(22047 2195)",
    fill: "none",
    stroke: "#0182f0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 74,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 64,
    height: 72,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    transform: "translate(22086 2271) rotate(90)",
    fill: "none",
    stroke: "#0182f0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.311,7.5H6.5",
    transform: "translate(22069 2183.5)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxDevice);
export default __webpack_public_path__ + "static/media/PAX-device.2483c39f80e7cd3fa442c1a0d5c4fe9a.svg";
export { ForwardRef as ReactComponent };